if (!customElements.get('drkn-color-variant-selects')) {

    /**
     *  @class
     *  @function VariantSelects
     */
    class DrknColorVariantSelects extends HTMLElement {
        constructor() {
            super();
            this.addEventListener('change', this.onVariantChange);
        }

        onVariantChange(event) {
            const input = event.target;
            this.selectedSize = document.querySelector('input[type="radio"][data-size-option]:checked');
            this.selectedProductUrl = input.getAttribute('data-product-url');
            for (const input of this.querySelectorAll('input[type="radio"]')) {
                input.removeAttribute('checked');
            }
            input.setAttribute('checked', 'checked');
            if (!this.dataset.template) {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
            this.fetchProductData();
        }

        fetchProductData() {
            console.log(this.selectedProductUrl);
            fetch(this.selectedProductUrl)
                .then(response => response.text())
                .then(responseText => {
                    let source, destination;
                    const html = new DOMParser().parseFromString(responseText, 'text/html');
                    if (this.dataset.template === 'quick-view') {
                        html.querySelector('drkn-color-variant-selects').setAttribute('data-template', 'quick-view');
                        // Images
                        source = html.querySelector('.product-quick-images');
                        destination = document.querySelector('.product-quick-images');
                        destination.innerHTML = source.innerHTML;

                        // Information
                        source = html.querySelector('.product-information--inner');
                        destination = document.querySelector('.product-information--inner');
                        destination.innerHTML = source.innerHTML;
                    } else {
                        // Main content
                        source = html.querySelector('#MainContent');
                        destination = document.querySelector('#MainContent');
                        destination.innerHTML = source.innerHTML;
                        window.history.replaceState({}, '', `${this.dataset.shopUrl}${this.selectedProductUrl}`);
                    }
                    const selectedSizeInput = destination.querySelector(`input[value="${this.selectedSize.value}"]`);
                    selectedSizeInput.click();
                });
        }
    }

    customElements.define('drkn-color-variant-selects', DrknColorVariantSelects);
}